import { get } from "lodash";
import { createSelector } from "reselect";
import { getPageContent } from "../../shared/selectors";

const getProductTypes = createSelector([getPageContent], pageContent => {
  return get(pageContent, "product_types", []);
});

export default getProductTypes;
